import React, { Component } from 'react';
import {NavLink, Link} from "react-router-dom";
import logodashheader  from '../Assets/logo-dash-header.png';
import FeedBackImg from '../Assets/ratings-review.png';
import Footer from "../Components/footer";
import  Header  from "../Components/header";
import SideBar from "../Components/sidebar";
import Button from "../Components/button";
import DataTable from "../Components/datatabledownloads";
import { DateTime, RedirectNotLogin, RedirectNotContractor, getSession, UpdateState, getState, handleSubmit, BreedForm, AlertMessage, AlertMessageOut, serializeArray } from "../Components/function";

class Downloads extends Component{

  constructor(props){
    super(props);
    
    this.state = {
      userID : '',
      scriptID: '',
      file: '',
      message: '',
    }
    }
    
    componentDidMount(){
      RedirectNotLogin();
      RedirectNotContractor();
    }

    componentDidUpdate() {
      RedirectNotLogin();
      RedirectNotContractor();
    }
 
  render(){
    return (
        <div className="App AppWrap">
    
    <Header self={this}/>
    <SideBar self={this}/>

    <div className="App iBG dash-dash">
    <div className="containers">
   

  <div className="card-lt-wrap">
    <div className="card-lt">
     
     {AlertMessageOut(this)}

     <DataTable
     route="mydownloads"
     badge={['', '', '']}
     thclassX={['', 'nowrap', 'nowrap']}
     th={
        ['Script ID', 'Downloads', 'Download Date']
     }
     td={
        ['scriptID', 'downloads', 'added']
    }
     cmd="mydownloads"
     self={this}
     />

    
     </div>

        <Footer classX="dash-footer"/>

    </div>
    
    </div>

    </div>

    </div>
    );
}

}

export default Downloads;